<template>
  <div
    :class="['email-component', 'image-component', { selected }]"
    @click="handleClick"
  >
    <div class="component-content" :style="getContainerStyles()">
      <img
        :src="getImageSource()"
        :alt="componentData.alt || 'Image'"
        :style="getImageStyles()"
        class="email-image"
        @error="handleImageError"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageComponent',
  props: ['componentData', 'selected'],
  methods: {
    handleClick() {
      this.$emit('click')
    },

    getContainerStyles() {
      // Get alignment - prioritize alignment property, then styles.textAlign
      const alignment = this.componentData.alignment || this.componentData.styles?.textAlign || 'center'

      return {
        textAlign: alignment,
        display: 'block',
        marginTop: this.componentData.styles?.marginTop || '16px',
        marginBottom: this.componentData.styles?.marginBottom || '16px'
      }
    },

    getImageSource() {
      // Use uploaded S3 URL if available, fallback to src, then placeholder
      return this.componentData.uploadedUrl ||
        this.componentData.src ||
        'https://console.offthecouch.io/img/placeholder.jpg'
    },

    getImageStyles() {
      const styles = { ...this.componentData.styles }

      // Remove textAlign from image styles as it should be on container
      delete styles.textAlign
      delete styles.marginTop
      delete styles.marginBottom

      return {
        ...styles,
        display: 'inline-block',
        maxWidth: '100%',
        height: 'auto'
      }
    },

    handleImageError(event) {
      // Fallback to placeholder if image fails to load
      event.target.src = 'https://console.offthecouch.io/img/placeholder.jpg'
    }
  }
}
</script>

<style scoped>
.image-component {
  position: relative;
  transition: all 0.2s ease;
}

.image-component.selected {
  outline: 2px solid #e14eca;
  outline-offset: 2px;
}

.email-image {
  display: inline-block;
  max-width: 100%;
  height: auto;
  border-radius: 4px;
}

.component-content {
  padding: 0;
}
</style>
